import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { parseParams } from "../../../helpers/clean-object";

import {
  CreateScanMutation,
  CreateScanMutationVariables,
} from "../../../__generated__/CreateScanMutation";
import { CreateScanInput } from "../../../__generated__/globalTypes";
import { CREATE_SCAN } from "../scans.queries";

interface IProps {
  defaultValues: CreateScanInput;
  onCompleted: () => any;
  onError: (message: string) => any;
}

export const useCreateScan = ({
  defaultValues,
  onCompleted,
  onError,
}: IProps) => {
  const form = useForm<CreateScanInput>({
    mode: "all",
    defaultValues,
  });

  const [mutate, { loading }] = useMutation<
    CreateScanMutation,
    CreateScanMutationVariables
  >(CREATE_SCAN);

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createScan?.ok) {
        onCompleted();
      } else {
        throw Error(data?.createScan?.error ?? "Error");
      }
    } catch (error) {
      onError(error.message);
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
